<div class="await-container">
    <div class="content" *ngIf="showVideo">
        <div>
            <video #videoElement autoplay playsinline muted class="video-feed"></video>
        </div>
        <!-- <button class="action-btn" (click)="onStartExam()" *ngIf="!examStarted">Take Exam</button> -->
        <div class="loading-info">
            <h1 class="title">Please Wait</h1>
            <p class="message">Please wait while we authenticate you...</p>
            <!-- <div class="progress-bar">
                <div class="progress-fill"></div>
            </div> -->
            
            <div class="loader">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
            </div>
            <div class="instructions">
                <p class="sub-text">📌 Ensure good lighting conditions.</p>
                <p class="sub-text">📌 Keep your eyes open and focused on the screen.</p>
                <p class="sub-text">📌 Move close to your screen and position your within the circle.</p>
                <p class="sub-text">📌 Remove glasses, hats, and other accessories and keep your face unobstructed.</p>
            </div>
        </div>
    </div>
    <div class="error-container" *ngIf="proctorError$ && !showVideo">
        <p class="error-message">{{ proctorError$ }}</p>
        <button class="action-btn" (click)="restartProcess()" style="pointer-events: auto; position: relative; z-index: 9999;">Reload</button>
    </div>
</div>
